var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBlackDownloadButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5279 7.61936L8.5625 9.68392V0.590278C8.5625 0.264276 8.32465 0 8.03125 0C7.73785 0 7.5 0.264276 7.5 0.590278V9.64988L5.56705 7.61936C5.34073 7.37688 4.97311 7.37688 4.74786 7.61936C4.52155 7.86183 4.52155 8.25744 4.74786 8.49992L6.81973 10.6775C7.5008 11.4096 8.59623 11.4073 9.27517 10.6775L11.347 8.49992C11.5734 8.25744 11.5734 7.86183 11.347 7.61936C11.1218 7.37688 10.7542 7.37688 10.5279 7.61936ZM16 10.625V13.8188C16 14.9889 15.0496 15.9375 13.8813 15.9375H2.19779C1.02767 15.9375 0.0791016 14.9871 0.0791016 13.8188V10.625H1.1416V13.8188C1.1416 14.4011 1.61526 14.875 2.19779 14.875H13.8813C14.4636 14.875 14.9375 14.4013 14.9375 13.8188V10.625H16Z",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDownloadButton);
export default __webpack_public_path__ + "static/media/BlackDownloadButton.c1eb83a7d4e7408fa14091bcc45b3642.svg";
export { ForwardRef as ReactComponent };